/* import __COLOCATED_TEMPLATE__ from './app-sso-domain-verification-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();